// @flow
import * as React from 'react'
import SVGResponsive, { type PublicProps } from 'icon/SVGResponsive'

type Props = PublicProps & {
  color: string,
}

export default class ChevronIcon extends React.Component<Props> {
  static defaultProps = {
    description: '',
    color: 'currentColor',
  }

  render = () => {
    const { color, ...rest } = this.props

    return (
      <SVGResponsive {...rest} width={14} height={9}>
        <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="square">
          <path d="M2 1.757l4.95 4.95M7 7l4.95-4.95" />
        </g>
      </SVGResponsive>
    )
  }
}
